import { render, staticRenderFns } from "./PreviewIconElement.vue?vue&type=template&id=be0727b8&"
import script from "./PreviewIconElement.vue?vue&type=script&lang=js&"
export * from "./PreviewIconElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports